import { BaseModel } from "model/BaseModel";
import DocumentoVersao from "../DocumentoVersao";

export default class FinalizarRevisao implements BaseModel {
    id: number;
    codigo = "";
    versao: number;
    observacao: string;
    versaoVigente: DocumentoVersao | null

    constructor(
        id: number = 0,
        versao = 0,
        observacao = "",
        versaoVigente: DocumentoVersao | null = null
    ) {
        this.id = id;
        this.versao = versao;
        this.observacao = observacao;
        this.versaoVigente = versaoVigente;
    }
}